/**
 * Main scripts for Taroschool
 */

/*global FB:false*/

(function ($) {

  "use strict";


})(jQuery);


// メインルーチン
jQuery(document).ready(function ($) {
  "use strict";

  // mmenu
  $("#global-nav-menu").mmenu({
    iconPanels: true,
    navbars   : [
      true, // trueを渡すと普通のタイトルバーが出る
      {
        position: 'top',
        content : [
          '<form class="mm-search" method="get" action="/"><input name="s" type="search" placeholder="サイト内を検索" /> </form>'
        ]
      }
    ]

  }, {
    offCanvas: {
      pageNodetype: '#whole-body'
    }
  });

  // Clipboard
  new Clipboard('.btn-clipboard');

  // Carousel
  $('.carousel').slick({
    dots: true,
    fade: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000
  });

  // Topに戻る
  var timer = null;
  $(window).scroll(function(e){
    if ( timer ) {
      clearTimeout( timer );
    }
    timer = setTimeout(function(){
      var top = jQuery(document).scrollTop();
      if ( top < 500 ) {
        if ( $('#to-top').hasClass('on') ) {
          $('#to-top').removeClass('on');
        }
      } else {
        if ( ! $('#to-top').hasClass('on') ) {
          $('#to-top').addClass('on');
        }
      }
    }, 300);

    // $('#to-top').click(function(e){
    //   e.preventDefault();
    //   if ( $(this).hasClass('on') ) {
    //     // トップに戻る
    //     $("body").animate({
    //       scrollTop: $('html').css('margin-top')
    //     }, 500);
    //   }
    // });

  });

});
